import React, { useEffect } from 'react';
import { BeforeAfter } from './components/BeforeAfter';
import { BonusSection } from './components/BonusSection';
import { DevelopmentPath } from './components/DevelopmentPath';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { Guarantee } from './components/Guarantee';
import { Hero } from './components/Hero';
import { PainPoints } from './components/PainPoints';
import { PricingSection } from './components/PricingSection';
import { ProductCarousel } from './components/ProductCarousel';
import { SolutionReveal } from './components/SolutionReveal';
import { SystemOverview } from './components/SystemOverview';
import { VolumesSection } from './components/VolumesSection';
import { WhoItsFor } from './components/WhoItsFor';
const META_PIXEL_ID = '1651357612587495';
type MetaPixel = ((...args: unknown[]) => void) & {
  callMethod?: (...args: unknown[]) => void;
  queue?: unknown[][];
  push?: (...args: unknown[]) => void;
  loaded?: boolean;
  version?: string;
};
declare global {
  interface Window {
    fbq?: MetaPixel;
    _fbq?: MetaPixel;
  }
}
export function App() {
  useEffect(() => {
    if (typeof window === 'undefined' || typeof document === 'undefined') return;
    try {
      if (!window.fbq) {
        const pixel: MetaPixel = (...args: unknown[]) => {
          if (pixel.callMethod) pixel.callMethod(...args);else pixel.queue?.push(args);
        };
        pixel.queue = [];
        pixel.loaded = true;
        pixel.version = '2.0';
        pixel.push = (...args: unknown[]) => pixel(...args);
        window.fbq = pixel;
        if (!window._fbq) window._fbq = pixel;
        const script = document.createElement('script');
        script.async = true;
        script.src = 'https://connect.facebook.net/en_US/fbevents.js';
        const first = document.getElementsByTagName('script')[0];
        if (first?.parentNode) first.parentNode.insertBefore(script, first);else document.head.appendChild(script);
        window.fbq('init', META_PIXEL_ID);
      }
      window.fbq('track', 'PageView');
    } catch (error) {
      console.warn('Meta Pixel initialization failed:', error);
    }
  }, []);
  return <div className="min-h-screen w-full bg-sand-light text-ink selection:bg-seafoam/50 selection:text-forest-dark" data-id="element-0" data-mp="d45uo6rhyho5">
      <noscript data-id="element-1" data-mp="83i1pfjpjqra">
        <img height="1" width="1" style={{
        display: 'none'
      }} src={`https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1`} alt="" data-id="element-2" data-mp="3gle88ef6yvd2" />
      </noscript>
      <main data-id="element-3" data-mp="3qbpl4qgusew3">
        <Hero data-id="element-4" data-mp="3qc966g1svjec" />
        <ProductCarousel data-id="element-5" data-mp="3qcr0360zplj3" />
        <PainPoints data-id="element-6" data-mp="3qdag2h72xzuh" />
        <SolutionReveal data-id="element-7" data-mp="3lkr5lt3ovktw" />
        <SystemOverview data-id="element-8" data-mp="3lk7q0j1ih8j1" />
        <VolumesSection data-id="element-9" data-mp="3liwlgh08rwqv" />
        <DevelopmentPath data-id="element-10" data-mp="3limsqlntbbhh" />
        <BonusSection data-id="element-11" data-mp="2xudb7vxmt9w5" />
        <PricingSection data-id="element-12" data-mp="2xtv76d4q9rdo" />
        <BeforeAfter data-id="element-13" data-mp="2xt28lzfxa86m" />
        <WhoItsFor data-id="element-14" data-mp="2xsk3edba8jmk" />
        <Guarantee data-id="element-15" data-mp="2sw24hu2mvfi5" />
        <FAQ data-id="element-16" data-mp="2suqxzmhsztnc" />
        <FinalCTA data-id="element-17" data-mp="2sv0qbgqbmcw7" />
      </main>
      <Footer data-id="element-18" data-mp="2stpjf81kwp0v" />
    </div>;
}